import { fetchApi } from 'src/_helpers/client/fetchApi'
import { buildUrl } from 'src/_helpers/buildUrl'

const PATH = '/api/open/authors'

async function getByUuid(uuid) {
  if (!uuid) {
    return null
  }

  const url = `${PATH}/${uuid}`

  return await fetchApi(url, 'GET', { accept: 'application/json' }, { next: { tags: [`authors:${uuid}`] } }).then(
    (response) => response,
    (error) => {
      if (error?.status === 404) {
        return null
      }

      throw new Error(`Failed to fetch author: ${url}`)
    },
  )
}

async function getPage(page, perPage, order = 'asc', filters = {}) {
  const normalizedFilters = Object.entries(filters || {}).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      acc[key] = value
    }
    return acc
  }, {})

  const url = buildUrl(PATH, {
    includeFacets: filters.includeFacets ?? true,
    'order[lastName]': order,
    'order[firstName]': order,
    page,
    perPage,
    ...normalizedFilters,
  })

  return await fetchApi(url, 'GET', { accept: 'application/ld+json' }, { next: { tags: ['authors'] } }).then(
    (response) => response,
    () => {
      throw new Error(`Failed to fetch authors: ${url}`)
    },
  )
}

async function getInitials(filters = {}) {
  const url = buildUrl('/api/open/author-initials', {
    orcid: filters.orcid || undefined,
    firstName: filters.firstName || undefined,
    lastName: filters.lastName || undefined,
    affiliationTitle: filters.affiliation || undefined,
    field: filters.field || undefined,
    discipline: filters.discipline || undefined,
  })

  return await fetchApi(url, 'GET', { accept: 'application/json' }, { next: { tags: ['authors'] } }).then(
    (response) => response,
    () => null,
  )
}

export const authorsService = {
  getByUuid,
  getPage,
  getInitials,
}
